import type { SearchRecord } from "./types";

export function toUrl(rec: SearchRecord) {
  return rec.anchor ? rec.route + "#" + rec.anchor : rec.route;
}
